// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"f7143d5f","498":"09e35692","703":"02386539"}[chunkId] + ".chunk.js";
};